import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';

export const PrepPaymentSuccess = () => (
  <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center px-4">
    <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center">
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <CheckCircle className="text-green-600" size={44} />
      </div>
      <h1 className="text-3xl font-bold text-gray-900 mb-3">Enrollment Confirmed!</h1>
      <p className="text-gray-600 mb-2">Your payment was successful. A confirmation email has been sent to you.</p>
      <p className="text-sm text-gray-400 mb-8">Head to your dashboard to start learning.</p>
      <Link to="/prep/dashboard">
        <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white text-lg py-6" data-testid="go-to-dashboard-btn">
          Go to My Dashboard
        </Button>
      </Link>
      <Link to="/prep/programs" className="block mt-4">
        <Button variant="outline" className="w-full">Browse More Programs</Button>
      </Link>
    </div>
  </div>
);
